export const ADD_PRODUCT_TO_CART = 'ADD_PRODUCT_TO_CART'
export const REMOVE_CART_ITEM = 'REMOVE_CART_ITEM'
export const CART_SAVE_SHIPPING_ADDRESS= 'CART_SAVE_SHIPPING_ADDRESS'
export const CART_SAVE_PAYMENT_METHOD = 'CART_SAVE_PAYMENT_METHOD'
export const CART_EMPTY = 'CART_EMPTY'
export const CART_ADD_ITEM_FAILURE="CART_ADD_ITEM_FAILURE"